var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof mf_style !== "undefined") return resolve();
	__webpack_require__.l("https://lemoncare.lemonhc.com/ui/insu/resources/micro-frontend/style/dist/mf_style.js?v=ec488372-f63b-4e89", (event) => {
		if(typeof mf_style !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mf_style");
}).then(() => (mf_style));